<template>
    <div class="d-flex justify-content-between align-center">
        <template v-if="done">
            <div class="flex-grow-1 d-flex align-center g-26--text">
                <img
                    v-if="cardBrand && brandIcons[cardBrand]"
                    :src="brandIcons[cardBrand]"
                    width="24"
                    class="mr-2"
                />
                <img
                    v-if="cardBrand && paymentIcons[payment]"
                    :src="paymentIcons[payment]"
                    width="24"
                    class="mr-2"
                />
                <div class="mr-2">{{ cardLast4 }}</div>
                <v-chip class="mr-2" x-small :color="statusColor">{{
                    status
                }}</v-chip>
                <v-icon v-if="copyText" @click="copy">content_copy</v-icon>
            </div>
            <div class="text-body-1 g-26--text">
                {{ price | currency(currency, currencyLocale) }}
            </div>
        </template>
        <template v-else>
            <div class="flex-grow-1 d-flex align-center">
                <div class="mr-3">
                    {{
                        $t('orders.paid_by_method', {
                            method: $t(`enums.payment_methods.stripe`),
                        })
                    }}
                </div>
                <v-chip class="mr-2" x-small :color="statusColor">{{
                    $t('labels.pending')
                }}</v-chip>
            </div>
        </template>
    </div>
</template>
<script>
export default {
    props: {
        cardBrand: {
            type: String,
        },
        payment: {
            type: String,
        },
        cardLast4: {
            type: String,
        },
        status: {
            type: String,
        },
        price: {
            type: [String, Number],
        },
        copyText: {
            type: String,
        },
        currency: {
            type: String,
        },
        currencyLocale: {
            type: String,
        },
        done: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            brandIcons: {
                visa: require('../../../../../../assets/cardbrand/visa.svg'),
                mastercard: require('../../../../../../assets/cardbrand/mastercard.svg'),
                amex: require('../../../../../../assets/cardbrand/amex.svg'),
                diners: require('../../../../../../assets/cardbrand/diners.svg'),
            },
            paymentIcons: {
                apple_pay: require('../../../../../../assets/payment/apple_pay.svg'),
                google_pay: require('../../../../../../assets/payment/google_pay.svg'),
                link: require('../../../../../../assets/payment/link.svg'),
            },
        }
    },
    computed: {
        statusColor() {
            return (
                {
                    succeeded: 'success',
                }[this.status] || 'orange'
            )
        },
    },
    methods: {
        copy() {
            if (navigator.clipboard) {
                navigator.clipboard.writeText(this.copyText)
            }
        },
    },
}
</script>
